import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CustomerSelectionOption } from '@app/customer/models/customer-selection-option.model';
import { CustomerSelectionVM } from '@app/customer/models/customer-selection-vm.model';
import { CustomerBankAccount } from '@usf/payment-types';
import { BehaviorSubject, Observable } from 'rxjs';
import { AutopaySteps } from '../autopay-steps/autopay-steps.enum';
import {
  AutopayConfirmationForm,
  AutopayDetails,
} from '../confirm-autopay-details/confirm-autopay-details.component';
import { BankToggleOptions } from '../segments-bank-account/bank-toggle-options.enum';

@Component({
  selector: 'app-set-up-autopay',
  templateUrl: './set-up-autopay.component.html',
  styleUrls: [
    './set-up-autopay.component.scss',
    '../add-bank-account-modal.component.scss',
  ],
})
export class SetUpAutopayComponent {
  @Input() currentAutopayStep: number;
  @Input() selectedCustomers: CustomerSelectionOption[];
  @Input() effectiveDate: Date;
  @Input() addBankAccountForm: FormGroup;
  @Input() selectedBankAccount: CustomerBankAccount;
  @Input() selectedSegment: BankToggleOptions;
  @Input() searchText$: BehaviorSubject<string>;
  @Input() vmWithCustomers$: Observable<CustomerSelectionVM>;
  @Input() bankAccounts: CustomerBankAccount[];
  @Input() isMobile: boolean;
  @Input() isDesktop: boolean;
  @Input() canModifyForm: boolean;
  @Input() isBankRoutingValidationOn: boolean;
  @Output() changeAutopayStepEmit = new EventEmitter<number>();
  @Output() isLoadingEmit: EventEmitter<boolean> = new EventEmitter();
  @Output() setSelectedSegmentEmit = new EventEmitter<BankToggleOptions>();
  @Output() isConfirmationValidEmit =
    new EventEmitter<AutopayConfirmationForm>();
  @Output() selectCustomersEmit = new EventEmitter<CustomerSelectionOption[]>();
  @Output() selectBankAccountEmitter = new EventEmitter<CustomerBankAccount>();
  @Output() selectEffectiveDateEmitter = new EventEmitter<Date>();

  readonly toggleOptions = BankToggleOptions;
  readonly autopaySteps = AutopaySteps;
  constructor() {}

  validateFormForAutopay() {
    this.addBankAccountForm.markAllAsTouched();
    if (this.addBankAccountForm.valid)
      this.changeAutopayStep(this.autopaySteps.stepTwo);
  }

  changeAutopayStep(step: number) {
    this.changeAutopayStepEmit.emit(step);
  }

  isFormLoading(isLoading: boolean) {
    this.isLoadingEmit.emit(isLoading);
  }

  selectCustomers(newSelectedCustomers: CustomerSelectionOption[]) {
    this.selectCustomersEmit.emit(newSelectedCustomers);
  }

  selectBankAccount(bankAccount: CustomerBankAccount) {
    this.selectBankAccountEmitter.emit(bankAccount);
  }

  selectEffectiveDate(date: Date) {
    this.selectEffectiveDateEmitter.emit(date);
  }

  setConfirmationValid(confirmationForm: AutopayConfirmationForm) {
    this.isConfirmationValidEmit.emit(confirmationForm);
  }

  setSelectedSegment(segment: BankToggleOptions) {
    this.setSelectedSegmentEmit.emit(segment);
  }

  get autopayDetails(): AutopayDetails {
    return {
      customers: this.selectedCustomers,
      autoDeductStartDate: this.effectiveDate,
      ...(this.selectedSegment === this.toggleOptions.existingAccount
        ? {
            bankName: this.selectedBankAccount.bankName,
            nickName: this.selectedBankAccount.nickName,
            accountNumber: this.selectedBankAccount.last4AccountNumber,
          }
        : {
            bankName: this.addBankAccountForm.controls.bankName.value,
            nickName: this.addBankAccountForm.controls.nickName.value,
            accountNumber:
              this.addBankAccountForm.controls.checkingAccountNumber.value,
          }),
    };
  }
}
